"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySession = void 0;
const types_1 = require("../main/types");
class StudySession extends types_1.StudySessionType {
}
exports.StudySession = StudySession;
StudySession.converter = {
    toFirestore(data) {
        return {
            dayPlanDocId: data.dayPlanDocId,
            moduleId: data.moduleId,
            userId: data.userId,
            duration: data.duration,
            hasEnded: data.hasEnded,
            startDate: data.startDate,
            endDate: data.endDate,
            remainingAcquisitionTarget: data.remainingAcquisitionTarget,
            acquisitionProgress: data.acquisitionProgress,
            remainingReviewTarget: data.remainingReviewTarget,
            reviewProgress: data.reviewProgress,
            remainingPracticeTarget: data.remainingPracticeTarget,
            practiceProgress: data.practiceProgress,
            highestCorrectStreak: data.highestCorrectStreak,
            rightAcquisitionCount: data.rightAcquisitionCount,
            wrongAcquisitionCount: data.wrongAcquisitionCount,
            rightReviewCount: data.rightReviewCount,
            wrongReviewCount: data.wrongReviewCount,
            rightPracticeCount: data.rightPracticeCount,
            wrongPracticeCount: data.wrongPracticeCount
        };
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const id = snapshot.id;
        const dayPlanDocId = documentData.dayPlanDocId;
        const moduleId = documentData.moduleId;
        const userId = documentData.userId;
        const data = new StudySession(dayPlanDocId, moduleId, userId);
        data.id = id;
        data.duration = documentData.duration;
        data.hasEnded = documentData.hasEnded;
        data.startDate = documentData.startDate;
        data.endDate = documentData.endDate;
        data.remainingAcquisitionTarget = documentData.remainingAcquisitionTarget;
        data.acquisitionProgress = documentData.acquisitionProgress;
        data.remainingReviewTarget = documentData.remainingReviewTarget;
        data.reviewProgress = documentData.reviewProgress;
        data.remainingPracticeTarget = documentData.remainingPracticeTarget;
        data.practiceProgress = documentData.practiceProgress;
        data.highestCorrectStreak = documentData.highestCorrectStreak;
        data.rightAcquisitionCount = documentData.rightAcquisitionCount;
        data.wrongAcquisitionCount = documentData.wrongAcquisitionCount;
        data.rightReviewCount = documentData.rightReviewCount;
        data.wrongReviewCount = documentData.wrongReviewCount;
        data.rightPracticeCount = documentData.rightPracticeCount;
        data.wrongPracticeCount = documentData.wrongPracticeCount;
        return data;
    }
};
